import { type SystemI18n } from '@myre/domain-i18n-wordings';
import { wordingKeyEcho } from '@myre/ui-primitive-core';

import { InjectionToken } from '@angular/core';

/**
 * The wordings ui-primitive-tree-table reads. A frontend provides them from
 * the wordings it loaded, which type-checks them against the generated tree;
 * without one, each leaf answers its own key.
 */
export interface PrimitiveTreeTableWordings {
  _system: {
    treeTable: Pick<SystemI18n['treeTable'], 'foldAll' | 'unFoldAll'>;
  };
}

export const PRIMITIVE_TREE_TABLE_WORDINGS =
  new InjectionToken<PrimitiveTreeTableWordings>('PrimitiveTreeTableWordings', {
    providedIn: 'root',
    factory: () => wordingKeyEcho<PrimitiveTreeTableWordings>(),
  });
